/**
 * Inventario / core -- helpers compartidos por el nucleo y los modulos de pestana.
 *
 * MUDANZA SEP-INV-T2 (bitacora #9490): estas piezas vivian en InventarioView.js y las
 * usan varias pestanas. Se movieron TAL CUAL, sin cambiar una linea de logica.
 * Medido antes de mover: quien usa cada una y desde donde (analisis sin comentarios,
 * porque contarlos producia dos dependencias circulares que no existen).
 */
import { ApiBase } from '../../../infrastructure/api/ApiBase.js';

export const RECONTEO_ANALYZE_WEBHOOK = 'https://n8n.nexodigital360.com/webhook/reconteo/analyze';
export const RECONTEO_DECISION_WEBHOOK = 'https://n8n.nexodigital360.com/webhook/reconteo/decision';
export 
function isBusinessUser() {
  const locked = localStorage.getItem('nx_business_locked') === 'true';
  const role = localStorage.getItem('nx_role') || 'dev';
  return locked && role !== 'dev' && role !== 'admin';
}


// Deuda 4: era una copia del escape; ahora es el compartido.
import { esc } from '../../shared/texto.js';
// Se reexporta con el mismo nombre para no romper a quien lo importa de este archivo.
export { esc, esc as escOp };
export const PAGE_SIZE = 25;


export 
async function fetchSyncData(table, opts = {}) {
  const params = new URLSearchParams();
  if (opts.businessId) params.set('businessId', opts.businessId);
  if (opts.search) params.set('search', opts.search);
  params.set('page', opts.page || 1);
  params.set('pageSize', opts.pageSize || 200);
  return ApiBase.get(`/api/sync/${table}?${params}`);
}

/**
 * SR-T3 (SYNC-RECREAR-SAFE-V1-001): dedupe defensivo del crudo nexo_sync.sync_insumos
 * por sync_uuid (la cedula estable del insumo). Tras una re-migracion el crudo puede
 * traer N filas con el mismo sync_uuid (mismo insumo fisico) -> el kiosk mostraba
 * duplicados (p.ej. 114 vs 57 reales). Colapsamos por sync_uuid conservando la fila
 * mas reciente (updated_at). Las filas legacy SIN sync_uuid se conservan con una clave
 * compuesta (id|nombre) para no descartar insumos que aun no tienen cedula.
 *
 * @param {Array<{data?:object, rowId?:any, updatedAt?:string}>} items - filas /api/sync/insumos
 * @returns {Array} mismas filas sin duplicados por cedula
 */

export 
/**
 * SR-T3 (SYNC-RECREAR-SAFE-V1-001): dedupe defensivo del crudo nexo_sync.sync_insumos
 * por sync_uuid (la cedula estable del insumo). Tras una re-migracion el crudo puede
 * traer N filas con el mismo sync_uuid (mismo insumo fisico) -> el kiosk mostraba
 * duplicados (p.ej. 114 vs 57 reales). Colapsamos por sync_uuid conservando la fila
 * mas reciente (updated_at). Las filas legacy SIN sync_uuid se conservan con una clave
 * compuesta (id|nombre) para no descartar insumos que aun no tienen cedula.
 *
 * @param {Array<{data?:object, rowId?:any, updatedAt?:string}>} items - filas /api/sync/insumos
 * @returns {Array} mismas filas sin duplicados por cedula
 */
function dedupeInsumosBySyncUuid(items) {
  if (!Array.isArray(items)) return [];
  const byKey = new Map();
  for (const it of items) {
    const d = it?.data || {};
    const uuid = d.sync_uuid || d.syncUuid || null;
    const key = uuid
      ? `uuid:${uuid}`
      : `legacy:${d.id ?? it?.rowId ?? ''}|${String(d.nombre || d.Insumo || '').toLowerCase()}`;
    const prev = byKey.get(key);
    if (!prev) { byKey.set(key, it); continue; }
    const tNew = Date.parse(d.updated_at || it?.updatedAt || '') || 0;
    const tPrev = Date.parse(prev?.data?.updated_at || prev?.updatedAt || '') || 0;
    if (tNew >= tPrev) byKey.set(key, it);
  }
  return Array.from(byKey.values());
}


export 
async function fetchSyncStatus(businessId) {
  // T5: cache-busting para que el tab Informacion siempre refleje el estado real.
  const parts = [];
  if (businessId) parts.push(`businessId=${encodeURIComponent(businessId)}`);
  parts.push(`_=${Date.now()}`);
  return ApiBase.get(`/api/sync/status/summary?${parts.join('&')}`);
}




export const ENTRADA_INSUMOS_CACHE_TYPE = 'insumos_catalogo_entrada';

